import { css } from "@emotion/css"

import COLOR_CODE from "../../../constant/color"

const rowStyles = {
  title: css`
    height: 40px;
    border: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
  `,
  first: css`
    height: 105px;
    margin-top: -1px;
    border: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
  `,
  repeat: css`
    height: 40px;
    margin-top: -1px;
    border: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
  `,
  ellipsis: css`
    height: 33px;
  `,
  total: css`
    height: 50px;
    margin-top: -1px;
    border: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
  `,
}

export default rowStyles
